import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { toggleModalWorkspaceDelete } from '../../../redux/main/main.actions';
import { selectIsModalWorkspaceDeleteEnabled, selectModalWorkspaceDeleteData } from '../../../redux/main/main.selectors';
import { workspaceArchiveRequest } from '../../../redux/workspace/workspace.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalWorkspaceDelete.scss';

export const ModalWorkspaceDelete = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();

    const isOpen = useSelector(selectIsModalWorkspaceDeleteEnabled);
    const modalData = useSelector(selectModalWorkspaceDeleteData);

    const [workspace, setWorkspace] = useState(null);
    const [title, setTitle] = useState('');
    const [confirm, setConfirm] = useState('');

    useEffect(() => {
        setWorkspace(modalData?.workspace || null);

        if (!modalData?.workspace?.title) return;

        if (title !== modalData?.workspace?.title) {
            setTitle(modalData?.workspace?.title || '');
        }

        return () => { };
    }, [modalData]);

    // Type-to-confirm: the Delete button stays disabled until the typed name
    // matches the workspace title exactly.
    const canDelete = !!workspace?.id && confirm.trim() === title.trim() && !!title.trim();

    const reset = () => {
        setWorkspace(null);
        setTitle('');
        setConfirm('');
    };

    const handleCancel = () => {
        dispatch(toggleModalWorkspaceDelete(null));
        setTimeout(reset, 300);
    };

    const handleDelete = () => {
        if (!canDelete) return;
        trackEvent('app_modal_workspace_delete_submit', {
            page: 'app',
            type: 'modals',
        });
        dispatch(workspaceArchiveRequest({
            id: workspace.id,
            onSuccess: () => history.push('/diagrams'),
        }));
        dispatch(toggleModalWorkspaceDelete(null));
        setTimeout(reset, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass="modal-workspace-delete"
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_workspace_delete.header')}</div>
            <div className="modal-content-body">
                <div className="description-text">
                    {t('m_workspace_delete.desc_prefix')}<span className="text-title-bold">{title}</span>.
                </div>

                <div className="confirm-label">
                    {t('m_workspace_delete.confirm_prefix')}<span className="text-title-bold">{title}</span>{t('m_workspace_delete.confirm_suffix')}
                </div>
                <input
                    className="confirm-input"
                    type="text"
                    value={confirm}
                    placeholder={title}
                    autoComplete="off"
                    autoFocus={true}
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    onChange={(e) => setConfirm(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter' && canDelete) handleDelete(); }}
                />

                <div className="buttons-wrap">
                    <button className="button-second" onClick={handleCancel}>{t('b.cancel')}</button>
                    <button className="button-delete" onClick={handleDelete} disabled={!canDelete}>{t('b.delete')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalWorkspaceDelete;
